import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import MobileFacet from './MobileFacet'
import MobileRangeFacet from './MobileRangeFacet'
import MobileSorting from './MobileSorting'
import MobileSelectedFilters from './MobileSelectedFilters'
import { defaultConfig, sortOptions } from '../config'
import { useState, useEffect } from 'preact/hooks'
import { useProductFilters } from '@nosto/preact'

export default () => {
    const { loading, query, response, response: { products: { facets } } = {} } = useAppState()
    const { updateSearch } = useActions()
    const [activeFacet, setActiveFacet] = useState('')
    const { filters, removeAll } = useProductFilters()

    const activeSort =
        sortOptions.find((option) =>
            option.value.sort.every((v1) =>
                query.products?.sort?.find((v2) => v1.field === v2.field && v1.order === v2.order)
            )
        )?.id ?? defaultConfig.sort.id

    const selectedFiltersCount =
        query.products?.filter?.reduce(
            (acc, curr) => acc + (Array.isArray(curr.value) ? curr.value.length : 1),
            0
        ) ?? 0

    const docCount = response.products?.total ?? 0

    useEffect(() => {
        const banner = document.querySelector('#shopify-section-announcement-bar')
        const sidebarWrapper = document.querySelector('.ns-sidebar-wrapper')

        if (banner && sidebarWrapper) {
            const bannerHeight = banner.offsetHeight
            const initialTop = 56
            sidebarWrapper.style.top = `${initialTop + bannerHeight}px`
        }
    }, [])

    return facets?.length > 0 ? (
        <>
            {query.query != undefined && (
                <div class="nosto-search-header">
                    <h3>
                        Found {docCount} results for '{query.query}'
                    </h3>
                </div>
            )}
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for="ns-facet-sidebar-toggle"
            />
            <div
                class="ns-sidebar-wrapper ns-h-100 ns-background-white"
                style={loading ? 'opacity: 0.3;' : ''}>
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-filters-mobile-header">
                        <span class="ns-d-block">
                            FILTERS
                            {selectedFiltersCount > 0 && <span> ({selectedFiltersCount})</span>}
                        </span>

                        <label for="ns-facet-sidebar-toggle">
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13 1L1 13M1 1L13 13"
                                    stroke="#3C3C3C"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </label>
                    </div>
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            <MobileSorting />
                            {filters.length > 0 && (
                                <li class="ns-sidebar-dropdown">
                                    {/* <div class="ns-filters-buttons">
                                    <button class="ns-secondary-button">SECONDARY BTN</button>
                                    <button class="ns-primary-button">PRIMARY BTN</button>
                                </div> */}
                                    <MobileSelectedFilters />
                                </li>
                            )}

                            {facets?.map((facet) => {
                                switch (facet.type) {
                                    case 'terms':
                                        return (
                                            <MobileFacet
                                                facet={facet}
                                                isActive={activeFacet === facet.id}
                                                setActive={(active) => {
                                                    if (active) {
                                                        setActiveFacet(facet.id)
                                                    } else {
                                                        setActiveFacet('')
                                                    }
                                                }}
                                            />
                                        )
                                    case 'stats':
                                        return <MobileRangeFacet facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ''
    )
}
